import React from 'react';
import cx from 'classnames';

export interface EmptyValuePlaceholderProps {
  className?: string;
}

export function EmptyValuePlaceholder({
  className,
}: EmptyValuePlaceholderProps) {
  return (
    <span className={cx(className, 'font-bold text-base v2-text-neutral-900')}>
      -
    </span>
  );
}
